class BundleTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.td-bundle-tabs__tab');
    this.panels = this.querySelectorAll('.td-bundle-tabs__panel');
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  connectedCallback() {
    this.classList.add('js-initialized');
    this.setupEventListeners();
    this.initializeFirstTab();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  initializeFirstTab() {
    if (this.tabs.length > 0) {
      const firstTab = this.tabs[0];
      this.switchTab(firstTab.dataset.tab);
    }
  }

  setupEventListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick);
    });
  }

  removeEventListeners() {
    this.tabs.forEach(tab => {
      tab.removeEventListener('click', this.handleTabClick);
    });
  }

  handleTabClick(event) {
    this.switchTab(event.currentTarget.dataset.tab);
  }

  switchTab(tabId) {
    this.tabs.forEach(tab => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach(panel => {
      const isActive = panel.dataset.panel === tabId;
      panel.classList.toggle('active', isActive);
    });
  }
}

if (!customElements.get('bundle-tabs')) {
  customElements.define('bundle-tabs', BundleTabs);
}
